import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';

import { TEMPLATE_PREFIX } from '../environments/locale-config';

export const GET_ASSETS_PATH_TOKEN = 'GET_ASSETS_PATH_TOKEN';

@Component({
  selector: 'kh-img',
  standalone: true,
  styleUrls: ['./img.component.less'],
  imports: [CommonModule],
  templateUrl: TEMPLATE_PREFIX + 'img.component.html'
})
export class ImgComponent {
  private static _missingBaseFolders = new Set<string>();

  @Input() public addAssetsPath = true;
  @Input() public stopOnBaseFolderError = true;

  @Input() public set path(imagePath: string) {
    this.imagePath = this.addAssetsPath
      ? this.getAssetsPath(imagePath)
      : imagePath;

    this.apply();
  }

  public get path(): string {
    return this.imagePath;
  }

  @Input() public alt = '';
  @Input() public cssClass = '';
  @Input() public cssStyles: { [key: string]: string } = {};

  public imagePath!: string;
  public hasError = false;

  public constructor(
    private cdr: ChangeDetectorRef,
    @Inject(GET_ASSETS_PATH_TOKEN) private getAssetsPath: (path: string) => string
  ) {}

  public onError(): void {
    if (this.hasError) { return; }
    if (this.stopOnBaseFolderError) {
      const base = this.extractBaseFolder(this.imagePath);
      if (base) {
        ImgComponent._missingBaseFolders.add(base);
      }
    }

    this.hasError = true;
    this.cdr.markForCheck();
  }

  private apply(): void {
    if (!this.imagePath) { return; }
    if (this.stopOnBaseFolderError) {
      const base = this.extractBaseFolder(this.imagePath);
      if (base && ImgComponent._missingBaseFolders.has(base)) {
        this.hasError = true;
        this.cdr.markForCheck();
        return;
      }
    }

    this.hasError = false;
    this.cdr.markForCheck();
  }

  private extractBaseFolder(url: string): string | null {
    const m = url.match(/\/userfiles\/([^/]+)/i);
    return m ? m[1].toLowerCase() : null;
  }
}
